 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"chunk-commons":"chunk-commons","chunk-swiper":"chunk-swiper","draft":"draft"}[chunkId]||chunkId) + "." + {"chunk-02279422":"68e220a1","chunk-02a9c310":"45c9b60f","chunk-02f124d7":"828af747","chunk-0489846d":"0556fd46","chunk-0741e40a":"292dd23b","chunk-0b8a8360":"75565a40","chunk-109eee80":"ddc78fe4","chunk-28e89ae6":"5c6c0283","chunk-2d0e9761":"001a3ace","chunk-3d68772c":"bb3eef51","chunk-4d709677":"4c480319","chunk-4fa2633a":"ace18e95","chunk-5b52ed4b":"910fc631","chunk-62af95c0":"cc0e773c","chunk-653e0efe":"5c32e078","chunk-66647d02":"eefb7d9d","chunk-696ec29e":"5cbe86a7","chunk-78f89ffe":"17b3c450","chunk-7a9aca28":"d3ae9b82","chunk-7bf5b554":"7757fadc","chunk-7eae30b4":"ecba0e26","chunk-7f9b2e26":"e4352b72","chunk-commons":"0558d7c0","chunk-00c8bd95":"d804b869","chunk-02fbe165":"4e05533f","chunk-1699f524":"897cf717","chunk-17643b59":"cd9916b5","chunk-1a029e0b":"857500b0","chunk-2d0c1ccb":"02281462","chunk-3efe9898":"0048d5fd","chunk-6644fb50":"733bb67c","chunk-687f2164":"96f8b024","chunk-69b1a4ea":"754fc8c5","chunk-7259df70":"6e6081b7","chunk-768bf3aa":"1fab6027","chunk-76ad52aa":"9be161c8","chunk-784894fc":"acd6bee1","chunk-d8039130":"8abfe64e","chunk-f3b3e1fc":"9181b661","chunk-b4437b06":"c8033ce2","chunk-28e15f2e":"ffa05343","chunk-swiper":"100fd422","chunk-a7edbc2e":"d09a2327","chunk-28a4ffb6":"e2d82cd7","chunk-322ed1c0":"2c4b4e59","chunk-7557df96":"28d09170","chunk-041a8ef4":"b7e3c0a6","chunk-14e69847":"e92a3f1c","chunk-3a30f082":"da1cbc99","chunk-539e219a":"845a9a4c","chunk-79d33d99":"7eea0d78","chunk-7f254206":"10c19eb1","chunk-bf0cb860":"f917da2e","chunk-d07206d0":"20a022ba","chunk-d8818f30":"b3587afd","chunk-a48e4f52":"af5e1a47","draft":"5fe8d37d","chunk-0ed78d85":"f0998faa","chunk-24feb656":"9c409996","chunk-3e0b7444":"b7b3af04","chunk-4e838b96":"be7f8b58","chunk-654e41e9":"aa8ca27b","chunk-fa07134e":"fe9f060a","chunk-46485868":"c900b6ed","chunk-5206dc8e":"178a8f3c","chunk-3f41672c":"22194a0f","chunk-59b2f600":"3c7d22c1","chunk-7119e902":"bf2fd8ec"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-02279422":1,"chunk-02a9c310":1,"chunk-02f124d7":1,"chunk-0489846d":1,"chunk-0741e40a":1,"chunk-0b8a8360":1,"chunk-109eee80":1,"chunk-28e89ae6":1,"chunk-3d68772c":1,"chunk-4d709677":1,"chunk-4fa2633a":1,"chunk-5b52ed4b":1,"chunk-62af95c0":1,"chunk-653e0efe":1,"chunk-66647d02":1,"chunk-696ec29e":1,"chunk-78f89ffe":1,"chunk-7a9aca28":1,"chunk-7bf5b554":1,"chunk-7eae30b4":1,"chunk-7f9b2e26":1,"chunk-commons":1,"chunk-00c8bd95":1,"chunk-02fbe165":1,"chunk-1699f524":1,"chunk-17643b59":1,"chunk-1a029e0b":1,"chunk-3efe9898":1,"chunk-6644fb50":1,"chunk-687f2164":1,"chunk-69b1a4ea":1,"chunk-7259df70":1,"chunk-768bf3aa":1,"chunk-76ad52aa":1,"chunk-784894fc":1,"chunk-d8039130":1,"chunk-f3b3e1fc":1,"chunk-b4437b06":1,"chunk-28e15f2e":1,"chunk-swiper":1,"chunk-a7edbc2e":1,"chunk-28a4ffb6":1,"chunk-322ed1c0":1,"chunk-7557df96":1,"chunk-041a8ef4":1,"chunk-14e69847":1,"chunk-3a30f082":1,"chunk-539e219a":1,"chunk-79d33d99":1,"chunk-7f254206":1,"chunk-bf0cb860":1,"chunk-d07206d0":1,"chunk-d8818f30":1,"chunk-a48e4f52":1,"draft":1,"chunk-0ed78d85":1,"chunk-24feb656":1,"chunk-3e0b7444":1,"chunk-4e838b96":1,"chunk-654e41e9":1,"chunk-fa07134e":1,"chunk-46485868":1,"chunk-5206dc8e":1,"chunk-3f41672c":1,"chunk-59b2f600":1,"chunk-7119e902":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"chunk-commons":"chunk-commons","chunk-swiper":"chunk-swiper","draft":"draft"}[chunkId]||chunkId) + "." + {"chunk-02279422":"892d70c3","chunk-02a9c310":"d11f057b","chunk-02f124d7":"729a83bb","chunk-0489846d":"5459b96a","chunk-0741e40a":"e2fc4317","chunk-0b8a8360":"56946930","chunk-109eee80":"dea45a25","chunk-28e89ae6":"63a8c292","chunk-2d0e9761":"31d6cfe0","chunk-3d68772c":"b0b565f3","chunk-4d709677":"0e9d0ead","chunk-4fa2633a":"5618e9c7","chunk-5b52ed4b":"08476bd9","chunk-62af95c0":"881d79ef","chunk-653e0efe":"f7cf6587","chunk-66647d02":"3260d776","chunk-696ec29e":"d202a0a3","chunk-78f89ffe":"2a5c1135","chunk-7a9aca28":"386ef24f","chunk-7bf5b554":"23d1d4a1","chunk-7eae30b4":"144805ed","chunk-7f9b2e26":"b5210733","chunk-commons":"eb192897","chunk-00c8bd95":"9b2b9711","chunk-02fbe165":"bff65f52","chunk-1699f524":"0ac766ec","chunk-17643b59":"3e59d99b","chunk-1a029e0b":"b37750aa","chunk-2d0c1ccb":"31d6cfe0","chunk-3efe9898":"52ae97dd","chunk-6644fb50":"330685e7","chunk-687f2164":"58f91d36","chunk-69b1a4ea":"c139c94b","chunk-7259df70":"636c2ec6","chunk-768bf3aa":"8df643e7","chunk-76ad52aa":"dd2be042","chunk-784894fc":"5bca34f2","chunk-d8039130":"e8a9b904","chunk-f3b3e1fc":"83bfb170","chunk-b4437b06":"3b9cbb43","chunk-28e15f2e":"cb1f3bca","chunk-swiper":"3755cb66","chunk-a7edbc2e":"c3bf6b88","chunk-28a4ffb6":"6b88a4fb","chunk-322ed1c0":"aed1bbd6","chunk-7557df96":"e959237a","chunk-041a8ef4":"fa2b1f1e","chunk-14e69847":"aa3fc920","chunk-3a30f082":"0ef2a5b3","chunk-539e219a":"7257b5fd","chunk-79d33d99":"39063ed2","chunk-7f254206":"94727574","chunk-bf0cb860":"04a9d709","chunk-d07206d0":"3abe20e7","chunk-d8818f30":"ee742287","chunk-a48e4f52":"497cb80b","draft":"2da85ec1","chunk-0ed78d85":"a330cc63","chunk-24feb656":"864689aa","chunk-3e0b7444":"1877bfc7","chunk-4e838b96":"11f78c4b","chunk-654e41e9":"a8ff42d4","chunk-fa07134e":"e06d7584","chunk-46485868":"98883259","chunk-5206dc8e":"f7185d98","chunk-3f41672c":"0323195e","chunk-59b2f600":"07ca077b","chunk-7119e902":"49d55372"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//s1.igetcool.com/webactivity/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vue","chunk-igetcool","chunk-igcLib","chunk-html2canvas","chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
